import { render, staticRenderFns } from "./statAppointZixuanDates.vue?vue&type=template&id=024f7176"
import script from "./statAppointZixuanDates.vue?vue&type=script&lang=js"
export * from "./statAppointZixuanDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports